import { useLazyQuery } from "@apollo/client";
import { MFA_CHALLENGE } from "api/query";
import type {
  MfaChallengeQuery,
  MfaChallengeQueryVariables,
} from "graphql/generated";
import type { VerifyProps } from "pages/commons/mfa/mfaTypes";
import { useStores } from "stores";

/**
 * Sends the MFA code and keeps the trust token in `authStore`. A password
 * change or reset sends the token and its challenge.
 */
export const useVerifyMfaChallenge = () => {
  const { authStore } = useStores();
  const [mfaChallenge] = useLazyQuery<
    MfaChallengeQuery,
    MfaChallengeQueryVariables
  >(MFA_CHALLENGE, { fetchPolicy: "network-only" });

  const verifyMfaChallenge = async ({
    authCode,
    resetToken,
  }: VerifyProps & { resetToken?: string | null }) => {
    try {
      if (!authCode) return false;
      authStore.generateMfaChallengeToken();
      const { data } = await mfaChallenge({
        variables: {
          code: authCode,
          trustChallenge: authStore.mfaChallengeToken,
          ...(resetToken ? { resetToken } : {}),
        },
      });
      if (!data) return false;
      authStore.setMfaTrustToken(data.mfaChallenge?.trustToken);
      authStore.resetError();
      return true;
    } catch {
      return false;
    }
  };

  return { verifyMfaChallenge };
};
